import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import Lenis from "@studio-freight/lenis";

const TermsPage = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smooth: true, smoothTouch: false });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    window.scrollTo(0, 0);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="min-h-screen bg-black" data-testid="terms-page">
      <SEOHead
        title="Términos y Condiciones | Disruptiva"
        description="Términos y Condiciones de uso del sitio web y servicios de Disruptiva, agencia de comunicación estratégica."
        path="/terminos-y-condiciones"
      />
      <div className="max-w-3xl mx-auto px-6 pt-32 pb-24">
        <Link to="/" className="text-white/30 hover:text-white/60 text-sm font-space transition-colors">← Inicio</Link>
        <h1 className="font-space font-bold text-3xl md:text-4xl text-white mt-8 mb-12">Términos y Condiciones</h1>
        <div className="legal-content">
          <p>Última actualización: 31 de marzo de 2026</p>
          <p>Estos Términos y Condiciones regulan el uso del sitio web <strong>www.disruptiva.online</strong> y los servicios ofrecidos por <strong>Disruptiva</strong> ("la empresa", "nosotros"). Al acceder y utilizar este sitio, aceptas estos términos en su totalidad.</p>

          <h2>1. Servicios</h2>
          <p>Disruptiva es una agencia de comunicación estratégica que ofrece servicios de:</p>
          <ul>
            <li>Reputación corporativa y comunicación estratégica.</li>
            <li>Gestión de crisis 360°.</li>
            <li>Relaciones públicas y media influence.</li>
            <li>Producción de contenido y audiovisual.</li>
          </ul>
          <p>Los servicios específicos, alcance, entregables y condiciones comerciales se detallan en la propuesta o contrato individual acordado con cada cliente.</p>

          <h2>2. Uso del sitio web</h2>
          <p>Al utilizar este sitio web, te comprometes a:</p>
          <ul>
            <li>Proporcionar información veraz y actualizada en los formularios de contacto.</li>
            <li>No utilizar el sitio con fines ilegales o no autorizados.</li>
            <li>No intentar acceder de forma no autorizada a sistemas o datos del sitio.</li>
            <li>No reproducir, distribuir o modificar el contenido sin autorización escrita.</li>
          </ul>

          <h2>3. Propiedad intelectual</h2>
          <p>Todos los contenidos del sitio web — incluyendo pero no limitado a textos, imágenes, logotipos, diseños, videos, gráficos y código fuente — son propiedad de Disruptiva o de sus respectivos titulares, y están protegidos por las leyes de propiedad intelectual aplicables.</p>
          <p>Queda prohibida la reproducción total o parcial sin consentimiento previo por escrito.</p>

          <h2>4. Chatbot e Inteligencia Artificial</h2>
          <p>El asistente virtual disponible en el sitio utiliza inteligencia artificial y tiene carácter informativo. Las respuestas proporcionadas:</p>
          <ul>
            <li>No constituyen asesoramiento legal, financiero ni profesional vinculante.</li>
            <li>Son orientativas y deben ser confirmadas por un representante humano de Disruptiva.</li>
            <li>Pueden contener inexactitudes inherentes a la tecnología de IA.</li>
          </ul>

          <h2>5. Confidencialidad</h2>
          <p>Toda la información compartida por los clientes durante el proceso de consulta, diagnóstico y prestación de servicios se trata con estricta confidencialidad. Los acuerdos específicos de confidencialidad se establecen en los contratos individuales de servicio.</p>

          <h2>6. Limitación de responsabilidad</h2>
          <p>Disruptiva no se responsabiliza por:</p>
          <ul>
            <li>Daños indirectos o consecuentes derivados del uso del sitio web.</li>
            <li>Interrupciones temporales del servicio por mantenimiento o causas de fuerza mayor.</li>
            <li>Contenido de sitios web de terceros enlazados desde este sitio.</li>
            <li>Resultados específicos de campañas, ya que dependen de múltiples factores externos.</li>
          </ul>

          <h2>7. Pagos y facturación</h2>
          <p>Las condiciones de pago, montos, plazos y métodos se establecen en cada propuesta o contrato individual. El incumplimiento de pagos puede resultar en la suspensión de los servicios contratados.</p>

          <h2>8. Cancelación</h2>
          <p>Las condiciones de cancelación se establecen en cada contrato individual. En general, las cancelaciones deben comunicarse por escrito con al menos 30 días de anticipación.</p>

          <h2>9. Ley aplicable</h2>
          <p>Estos Términos y Condiciones se rigen por las leyes de la República de El Salvador. Cualquier controversia será sometida a la jurisdicción de los tribunales competentes de San Salvador.</p>

          <h2>10. Contacto</h2>
          <p>Para consultas sobre estos Términos y Condiciones:</p>
          <ul>
            <li>Correo: informacion@disruptiva.online</li>
            <li>Teléfono: +503 6433 0431</li>
          </ul>

          <h2>11. Modificaciones</h2>
          <p>Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios serán efectivos desde su publicación en esta página.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
